import type {
  ElementState,
  PaginationState,
  SelfDataState,
  CallApi,
  singleElementState,
} from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type { ElementStateWithCount } from "@/types/store";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};
const singleElementSate: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};
const paginationState: PaginationState = {
  data: [],
  count: 0,
  error: null,
  loading: false,
};

const callApi: CallApi = {
  error: null,
  loading: false,
};

const elementCountState: ElementStateWithCount<any> = {
  data: [],
  count: 0,
  error: null,
  loading: false,
};

export const selfDataState: SelfDataState = {
  buildings: elementSate,
  variables: paginationState,
  variablesExport: singleElementSate,
  imports: paginationState,
  currentFileImport: {},
  downloadConfigs: elementSate,
  downloadRequest: callApi,
  files: elementSate,
  historyVariableChange: elementCountState,
};

export const SelfDataModule = {
  namespaced: true,
  state: selfDataState,
  getters,
  actions,
  mutations,
};
